import React, { useState, useEffect, useRef } from 'react';
import { useApp } from '../../../context/AppContext';
import useAnalytics from '../../../hooks/useAnalytics';

import './QuestionSlide.scss';

const QuestionSlide = ({ questionId, title, description, options }) => {
  const { state, actions } = useApp();
  const [selectedAnswer, setSelectedAnswer] = useState(
    state.questionAnswers[questionId] || null
  );
  const [hoveredOption, setHoveredOption] = useState(null);
  const hasTrackedRef = useRef(false);
  const { trackCoreValueLoad, trackSpecialtyLoad } = useAnalytics();

  useEffect(() => {
    if (!hasTrackedRef.current) {
      if (questionId === 'q1') {
        trackCoreValueLoad();
      } else if (questionId === 'q2') {
        trackSpecialtyLoad();
      }

      hasTrackedRef.current = true;
    }
  }, [trackCoreValueLoad, trackSpecialtyLoad]);

  useEffect(() => {
    const contextAnswer = state.questionAnswers[questionId] || null;
    if (contextAnswer !== selectedAnswer) {
      setSelectedAnswer(contextAnswer);
    }
  }, [state.questionAnswers, questionId, selectedAnswer]);

  const handleOptionSelect = (optionValue) => {
    if (optionValue !== selectedAnswer) {
      setSelectedAnswer(optionValue);
      actions.updateQuestionAnswer(questionId, optionValue);
    }
  };

  const getDisplayDescription = () => {
    if (hoveredOption) {
      const hoveredOpt = options.find((opt) => opt.value === hoveredOption);
      return hoveredOpt?.description || '';
    }

    if (selectedAnswer) {
      const selectedOpt = options.find((opt) => opt.value === selectedAnswer);
      return selectedOpt?.description || '';
    }

    return '';
  };

  return (
    <div className="slide question-slide">
      <div className="question-slide__container">
        <div className="question-slide__content">
          <p className="question-slide__description">{description}</p>

          <h2 className="question-slide__title">{title}</h2>

          <div className="question-slide__options">
            {options.map((option) => (
              <div
                key={option.value}
                className={`option-card ${selectedAnswer === option.value ? 'selected' : ''}`}
                onClick={() => handleOptionSelect(option.value)}
                onMouseEnter={() => setHoveredOption(option.value)}
                onMouseLeave={() => setHoveredOption(null)}
              >
                <div className="option-card__content">
                  <span className="option-card__label">{option.label}</span>
                </div>
              </div>
            ))}
          </div>

          <div className="question-slide__option-description">
            {getDisplayDescription() ? (
              <div
                className="option-description-text"
                dangerouslySetInnerHTML={{ __html: getDisplayDescription() }}
              />
            ) : selectedAnswer === null ? (
              <p className="option-description-placeholder">
                Select an option to see more details
              </p>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuestionSlide;
